<div>
  <img src="assets/images/Banner_Customer.png" alt="Banner_CRC">
</div>
